import ENV from 'web-app/config/environment';
import {getStore} from 'web-app/react/redux/store';

import {makeCreateAction} from './action-helpers';

/* Used to avoid circular reference,
 * redux store is evaluated only after lazyDispatch is called
 */
export const lazyDispatch = action => {
    getStore().dispatch(action);
};

/**
 * @deprecated Use the properly typed `createAction` from util/redux/typed-action-helpers.ts instead
 */
export const createAction = makeCreateAction(lazyDispatch, ENV.isDevelopment);
